import { Division, League } from "@Globals/types";

export type LeagueInfo = {
  priorLeague: League | null;
  league: League | null;
  nextLeague: League | null;
  division: Division | null;
  divisionKey: number;
  nextDivision: Division | null;
  allDivisions: Division[];
  remainingDivisions: number;
};

const getLeagueInfo = (leagues: League[], userRating: number, previousUserRating?: number): LeagueInfo => {
  let playersLeague: League | null = null;
  let playersNextLeague: League | null = null;
  let playersPreviousLeague: League | null = null;
  let playersDivision: Division | null = null;
  let playersNextDivision: Division | null = null;
  let playersDivisionKey = -1;
  let divisions: Division[] = [];
  let remainingDivisions = 0;
  leagues.forEach((league, i) => {
    if (league.rating_point <= userRating) {
      const tempPreviousLeague = playersLeague || null;
      playersLeague = league;
      playersNextLeague = leagues[i + 1] || null;
      league.divisions.forEach((division, n) => {
        divisions.push(division);
        if (division.rating_point <= userRating) {
          playersDivision = division;
          playersNextDivision = league.divisions[n + 1] ? league.divisions[n + 1] : playersNextLeague ? playersNextLeague.divisions[0] : null;
          playersDivisionKey = n;
          remainingDivisions = league.divisions.length - n - 1;
        } else if (playersPreviousLeague === null && previousUserRating && userRating > previousUserRating && n == 1) {
          //Promoted
          playersPreviousLeague = tempPreviousLeague;
        }
      });
    } else if (
      playersPreviousLeague === null &&
      previousUserRating &&
      previousUserRating > userRating &&
      playersLeague &&
      playersDivisionKey == playersLeague.divisions.length - 1
    ) {
      //Relegated
      playersPreviousLeague = league;
    }
  });

  return {
    priorLeague: playersPreviousLeague,
    league: playersLeague,
    nextLeague: playersNextLeague,
    division: playersDivision,
    divisionKey: playersDivisionKey,
    nextDivision: playersNextDivision,
    allDivisions: divisions,
    remainingDivisions,
  };
};

export default getLeagueInfo;
